import { Icon } from "@chakra-ui/react"

export const FacebookIcon = (props: any) => (
  <Icon xmlns="http://www.w3.org/2000/svg" width="23.239" height="23.239" viewBox="0 0 23.239 23.239" {...props}>
    <g transform="translate(5 -2)">
      <g transform="translate(-5 2)">
        <path d="M20.516,0H2.723A2.726,2.726,0,0,0,0,2.723V20.516a2.726,2.726,0,0,0,2.723,2.723H20.516a2.726,2.726,0,0,0,2.723-2.723V2.723A2.726,2.726,0,0,0,20.516,0Zm.908,20.516a.909.909,0,0,1-.908.908H15.342v-7.4h2.8l.463-2.814H15.342V9.259A1.339,1.339,0,0,1,16.7,7.9h1.861V5.084H16.7a4.175,4.175,0,0,0-4.175,4.184v1.944H9.8v2.814h2.724v7.4H2.723a.909.909,0,0,1-.908-.908V2.723a.909.909,0,0,1,.908-.908H20.516a.909.909,0,0,1,.908.908Z" fill="currentColor"/>
      </g>
    </g>
  </Icon>
);
